/***
 * Author : Guryash Singh Dhall
 * Description: Sign up page where user can register to the application.
 * From Scratch.
 ***/

import * as React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Link from "@mui/material/Link";
import CssBaseline from "@mui/material/CssBaseline";
import LoginSideImage from "../assets/images/login-invest-smart.png";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import validate from "../util/validation";
import { useHistory } from "react-router-dom";
import FormHelperText from "@mui/material/FormHelperText";

// Material UI Theme
const theme = createTheme();

export default function SignUpPage() {
  const history = useHistory();

  const [value, setValue] = React.useState("");
  // Error state to show appropriate errors in the field
  const [error, setError] = React.useState({
    email: "",
    password: "",
    confirmPassword: "",
    name: "",
    userType: "",
  });
  console.log("user", error);
  console.log("value", value);

  const handleRadioChange = (event) => {
    setValue(event.target.value);
    setError((previous) => Object.assign({}, { ...previous, userType: "" }));
  };

  // validation done on submit of the details
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const userType = data.get("radio-data");
    const validateObj = validate(data);
    if (!userType) {
      validateObj.userType = "Please select User Type";
    }
    if (
      validateObj.email ||
      validateObj.name ||
      validateObj.password ||
      validateObj.confirmPassword ||
      validateObj.userType
    ) {
      setError(Object.assign({}, validateObj));
      return;
    } else {
      localStorage.setItem("userType", userType);
      if (userType == "investor") {
        history.push("/investorHomePage");
      } else if (userType == "Entrepreneur") {
        history.push("/enterpreneurHomePage");
      }
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Box
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexFlow: "row wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={false}
            sm={12}
            md={12}
            lg={7}
            xl={4}
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              flexFlow: "column",
              alignItems: "center",
            }}
          >
            <Grid
              sx={{
                alignItems: "center",
                height: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                sx={{
                  height: 279.6,
                  width: 420,
                  maxHeight: { xs: 233, md: 466 },
                  maxWidth: { xs: 350, md: 700 },
                }}
                alt="The house from the offer."
                src={LoginSideImage}
              />
            </Grid>
          </Grid>
          {/* </Box> */}
          <Grid
            item
            xs={12}
            sm={12}
            md={5}
            component={Paper}
            elevation={6}
            square
            sx={{
              height: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexFlow: "column",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Box
                sx={{
                  mt: 16,
                  mx: 4,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  component="form"
                  noValidate
                  onSubmit={handleSubmit}
                  sx={{ mt: 1 }}
                >
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="name"
                    label="Name"
                    name="name"
                    autoComplete="name"
                    error={error.name !== ""}
                    helperText={error.name}
                    autoFocus
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email Address"
                    name="email"
                    error={error.email !== ""}
                    helperText={error.email}
                    autoComplete="email"
                    autoFocus
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="password"
                    type="password"
                    label="Password"
                    name="password"
                    error={error.password !== ""}
                    helperText={error.password}
                    autoComplete="password"
                    autoFocus
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="cnf_password"
                    label="Confirm Password"
                    type="password"
                    id="cnf_password"
                    autoComplete="current-password"
                    error={error.confirmPassword !== ""}
                    helperText={error.confirmPassword}
                  />

                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label"></FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="radio-data"
                      value={value}
                      onChange={handleRadioChange}
                    >
                      <FormControlLabel
                        value="investor"
                        control={<Radio />}
                        label="Investor"
                      />
                      <FormControlLabel
                        value="Entrepreneur"
                        control={<Radio />}
                        label="Entrepreneur"
                      />
                    </RadioGroup>
                    <FormHelperText sx={{ color: "#d32f30" }}>
                      {error.userType}
                    </FormHelperText>
                  </FormControl>
                  <br />
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 2,
                      bgcolor: "#194376",
                      width: "30%",
                    }}
                  >
                    Sign Up
                  </Button>
                  <Grid container>
                    {/* <Grid item xs>
                                            
                                        </Grid> */}

                    <Grid item xs={12}>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Link
                          onClick={() => {
                            history.push("/login");
                          }}
                          variant="body2"
                          style={{ cursor: "pointer" }}
                        >
                          {"Already a user? Sign In"}
                        </Link>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </ThemeProvider>
  );
}
